"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SpinsDynamicFetch;
var _react = _interopRequireDefault(require("react"));
var _SpinsDomainAndPrice = _interopRequireDefault(require("./SpinsDomainAndPrice"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
function SpinsDynamicFetch({
  language = {},
  priceData = {},
  options = {},
  AddToCartButton = () => /*#__PURE__*/_react.default.createElement("div", null),
  PriceBlock = () => /*#__PURE__*/_react.default.createElement("div", null)
}) {
  priceData.ExactMatchDomains = priceData.ExactMatchDomains || [];
  priceData.Products = priceData.Products || [];
  const {
    market = 'en-US'
  } = options;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "styled-spins-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    key: market,
    messages: language
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-white",
    "data-cy": "spins-barebones",
    "data-testid": "spins-barebones"
  }, /*#__PURE__*/_react.default.createElement(_SpinsDomainAndPrice.default, {
    PriceBlock,
    AddToCartButton,
    priceData,
    options
  }))));
}
SpinsDynamicFetch.propTypes = {
  language: _propTypes.default.object,
  priceData: _propTypes.default.object,
  options: _propTypes.default.object,
  AddToCartButton: _propTypes.default.func,
  PriceBlock: _propTypes.default.func
};